<template>
    <div class="splide splide--draggable is-active"
         id="header-categories-slider-1">
        <div class="splide__track">
            <div class="splide__list">
                <div v-for="(categorie, index) in categories" :key="index" class="splide__slide">
                    <router-link :to="{name: 'produits', params: {slug: categorie.slug}}" class="hcs-item">
                        <img :src="`/uploads/categories/${categorie.image}`" alt="">
                        <div class="hcs-item-text">{{ categorie.name }}</div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    computed: {
        categories() {
            return this.$store.state.categories.categories;
        }
    },
    mounted() {
        const slide = new Splide('#header-categories-slider-1', {
            type: 'loop',
            autoplay: false,
            interval: 4000,
            perPage: 5,
            arrows: true,
            pagination: false,
            breakpoints: {
                580: {
                    perPage: 3,
                    arrows: false
                },
                850: {
                    perPage: 4,
                },
                1000: {
                    perPage: 5,
                },
            }
        }).mount();
    }
}
</script>
